/* eslint-disable @typescript-eslint/no-empty-function */
import { reactive } from 'vue';
import vuetify from '../plugins/vuetify';
import { Props } from '../models/component';

interface Button {
  text: string,
  color: string,
}

interface State {
  resolve?: object | null,
  display?: boolean,
  title: string | undefined,
  text: string | undefined,
  color?: string,
  backgroundColor?: string,
  buttonYes?: Button,
  buttonNo?: Button,
  props?: Props,
}

interface Methods {
  show?(obj: State): Promise<void> | void,
  onClick(confirm: boolean): void,
}

interface Confirm extends State, Methods {}

const createState = () => {
  const state = reactive<Confirm>({
    resolve: null,
    display: false,
    title: '',
    text: '',
    show() {
      console.log('show');
    },
    onClick() {
      console.log('onClick');
    },
  });

  state.show = async (obj: State) => {
    const { theme } = vuetify;
    const { title, text, color, backgroundColor, buttonYes, buttonNo, props } = obj;
    state.title = title;
    state.text = text;
    state.color = color;
    state.backgroundColor = backgroundColor ?? ((theme.global.current.value.colors[color ?? ''] && `bg-${color}-opacity-1`) || undefined);
    state.buttonYes = { text: 'ยืนยัน', color: 'primary', ...(buttonYes ?? {}) };
    state.buttonNo = { text: 'ยกเลิก', color: 'primary', ...(buttonNo ?? {}) };
    state.props = { ...(props ?? { }) };
    state.display = true;
    return new Promise((resolve) => {
      state.resolve = resolve;
    });
  };

  state.onClick = (confirm: boolean) => {
    if (typeof state.resolve !== 'function') return;
    state.resolve(confirm);
    state.display = false;
  };

  return state;
};

const state = createState();

export default state;

export {
  State,
  Confirm,
  state,
  createState,
};
